module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"scroll":"Scrollen Sie für mehr"},"en":{"scroll":"Scroll for more"},"it":{"scroll":"Scorrere"},"lt":{"scroll":"Žemyn"},"pl":{"scroll":"Przewiń, by dowiedzieć się więcej"}}')
  delete Component.options._Ctor
}
